import React from 'react';
import { Typography, Container, Box, Stack, Grid, Link } from '@mui/material';
import { Link as RLink } from "react-router-dom";

import visaLogo from '../../assets/visa.png'
import mastercardLogo from '../../assets/mastercard.png'

export function Footer() {
  return (

    <Stack
      component="footer"
      direction="column"
      spacing={3}
      alignItems={'center'}
      sx={{
        py: 2,
        px: 2,
        background: '#00000022',
        backdropFilter: 'blur(5px)',
        boxShadow: '0px -1px 10px 0px #00000044',
      }}>

      <Container sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={2}
          justifyContent={'space-evenly'}>

          <Grid item xs={4} sm={2} md={2}>
            <Stack
              direction="column"
              alignItems={'flex-start'}
              sx={{
                color: 'text.secondary',
                // display: 'flex',
                // flexDirection: 'column',
                // justifyContent: 'space-between',
                // alignItems: 'flex-start',
                // flexGrow: 1,
                // flexBasis: '30%',
              }}>
              <Typography variant="subtitle1" mb={1} fontWeight={'bold'}>
                Links
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  as={RLink}
                  to="/">
                  Features
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  as={RLink}
                  to="/app">
                  Configs
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  as={RLink}
                  to="/app/topup">
                  Subscription
                </Link>
              </Typography>
            </Stack>
          </Grid>

          <Grid item xs={6} sm={3} md={3}>
            <Stack
              direction="column"
              alignItems={'flex-start'}
              sx={{
                color: 'text.secondary',
              }}>
              <Typography variant="subtitle1" mb={1} fontWeight={'bold'}>
                Legal
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  as={RLink}
                  to="/terms">
                  Terms of Service
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  as={RLink}
                  to="/privacy">
                  Privacy Policy
                </Link>
              </Typography>
            </Stack>
          </Grid>

          <Grid item xs={0} sm={2} md={3}>
            {/* <Stack
              direction="column"
              alignItems={'flex-start'}
              sx={{
                color: 'text.secondary',
                // display: 'flex',
                // flexDirection: 'column',
                // justifyContent: 'space-between',
                // alignItems: 'flex-start',
                // flexGrow: 1,
                // flexBasis: '30%',
              }}>
              <Typography variant="subtitle1" mb={1} fontWeight={'bold'}>
                Social
              </Typography>
              <Typography variant="subtitle2">
                <Link color="inherit"
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer">
                  Facebook
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link color="inherit"
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer">
                  Telegram
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link color="inherit"
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer">
                  Twitter
                </Link>
              </Typography>
            </Stack> */}
          </Grid>

          <Grid item xs={12} sm={5} md={4} xl={4}>
            <Stack
              direction="column"
              // spacing={{ xs: 1, sm: 2, md: 4 }}
              sx={{
                alignItems: { xs: 'center', sm: 'flex-start' },
              }}>
              <Typography variant="subtitle1" mb={1} fontWeight={'bold'}>
                Contact Us
              </Typography>
              <Typography variant="subtitle2">
                Ajman Free Zone C1 Building
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  color="inherit"
                  href="tel:+971504621407"
                  target="_blank"
                  rel="noopener noreferrer">
                  +971 504 621 407
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  color="inherit"
                  href="mailto:contact@wiredefense.net"
                  target="_blank"
                  rel="noopener noreferrer">
                  contact@wiredefense.net
                </Link>
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ pt: 1, gap: 4, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img
          src={visaLogo}
          alt="Visa Inc. Logo"
          style={{ height: '2rem', width: 'auto' }}
        />

        <img
          src={mastercardLogo}
          alt="Mastercard Logo"
          style={{ height: '3.5rem', width: 'auto' }}
        />
      </Box>

      <Typography variant="subtitle1" sx={{
        width: '100%',
        pt: 2,
        borderTop: '1px solid #00000022',
      }}>
        WireDefense Technology F.Z.E, 2025
      </Typography>
    </Stack>
  )
}

export default Footer;
